import { Form } from "antd";

import { useTranslation } from "src/translations";
import { SelectDynamic } from "../../../Form/formComponents";
import { HorizontalFormFieldStyle } from "../../../Form/formFieldLabelPositioning/styles/Styles";
import type { FieldMethod, FormFieldFactoryProps, SelectDynamicFormField } from "../../../Form/types/types";

export const EditableListSelectDynamicField: FieldMethod = ({ field, readOnly, rules }: FormFieldFactoryProps) => {
    const { t } = useTranslation();

    return (
        <HorizontalFormFieldStyle key={`${field.name}FormControl `}>
            <Form.Item key={`${field.name}FormItem`} name={field.name} rules={rules} label={t(field.translationKeys.label)}>
                <SelectDynamic
                    key={field.name}
                    name={field.name}
                    label={field.translationKeys.label}
                    fieldConfig={field as SelectDynamicFormField}
                    readOnly={readOnly}
                />
            </Form.Item>
        </HorizontalFormFieldStyle>
    );
};
